import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './Organizations.module.css';
import commonStyles from '../../common/CommonStyles.module.css';
import { useUserSearch } from '../../../hooks/useUserSearch';

const Organizations = () => {
  const [organizations, setOrganizations] = useState([]);
  const [editingOrg, setEditingOrg] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const {
    searchQuery,
    setSearchQuery,
    searchResults,
    isSearching,
    handleSearchChange,
    handleUserSelect,
    selectedUserId,
    setSelectedUserId
  } = useUserSearch();

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    try {
      const response = await fetch('/api/organizations');
      const data = await response.json();
      setOrganizations(data);
    } catch (error) {
      console.error('Error fetching organizations:', error);
    }
  };
  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить организацию?')) {
      await fetch(`/api/organizations/${id}`, { method: 'DELETE' });
      fetchOrganizations();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    const orgData = {
      name: formData.get('name'),
      description: formData.get('description'),
      location: formData.get('location'),
      leader: { id: selectedUserId }
    };

    const url = editingOrg ? `/api/organizations/${editingOrg.id}` : '/api/organizations';
    const method = editingOrg ? 'PUT' : 'POST';

    try {
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orgData)
      });

      if (response.ok) {
        fetchOrganizations();
        setIsModalOpen(false);
        setEditingOrg(null);
        setSearchQuery('');
      }
    } catch (error) {
      console.error('Error saving organization:', error);
    }
  };

  const renderLeaderSearch = () => (
    <div className={s.leaderSearch}>
      <div className={s.searchContainer}>
        <input
          type="text"
          placeholder="Поиск руководителя по ФИО..."
          value={searchQuery}
          onChange={handleSearchChange}
          className={s.searchInput}
          autoComplete="off"
        />
        {isSearching && <div className={s.loading}>Поиск...</div>}
        {searchResults.length > 0 && (
          <div className={s.searchResults}>
            {searchResults.map(user => (
              <div
                key={user.id}
                className={s.searchResultItem}
                onClick={() => handleUserSelect(user)}
              >
                {user.firstName} {user.lastName} ({user.email})
              </div>
            ))}
          </div>
        )}
      </div>
      <input type="hidden" name="leaderId" defaultValue={selectedUserId} />
    </div>
  );

  return (
    <div className={commonStyles.pageContainer}>
      <div className={commonStyles.contentContainer}>
        <div className={commonStyles.content}>
          <h2 className={s.title} style={{ color: 'rgb(151, 1, 14)', textAlign: 'center', fontFamily: 'Ysabeau SC, sans-serif' }}>
            Управление организациями
          </h2>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1.5rem' }}>
            <button
              onClick={() => {
                setIsModalOpen(true);
                setEditingOrg(null);
                setSearchQuery('');
              }}
              className={s.addButton}
              style={{ backgroundColor: 'rgb(151, 1, 14)', color: 'white', borderRadius: 4, fontWeight: 500 }}
            >
              <span style={{ fontSize: '1.2rem' }}>+</span> Добавить организацию
            </button>
          </div>
          <div className={s.tableContainer} style={{ background: 'white', borderRadius: 8, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            <table className={s.table} style={{ minWidth: 600 }}>
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Руководитель</th>
                  <th>Описание</th>
                  <th>Местоположение</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tbody>
                {organizations.map(org => (
                  <tr key={org.id} className={s.tableRow}>
                    <td>{org.name}</td>
                    <td>{org.leader?.firstName} {org.leader?.lastName}</td>
                    <td>{org.description}</td>
                    <td>{org.location}</td>
                    <td className={s.actionsCell}>
                      <button
                        onClick={() => navigate(`/admin/organizations/${org.id}/roles`)}
                        className={s.editButton}
                        style={{ backgroundColor: '#6a1b9a', color: 'white', borderRadius: 4, marginRight: 8 }}
                      >
                        Управление
                      </button>
                      <button
                        onClick={() => handleDelete(org.id)}
                        className={s.deleteButton}
                        style={{ backgroundColor: '#ff4444', color: 'white', borderRadius: 4 }}
                      >
                        Удалить
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {isModalOpen && (
            <div className={s.modal} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div className={s.modalContent} style={{ background: 'white', padding: '2rem', borderRadius: 8, width: '90%', maxWidth: 500 }}>
                <h3 style={{ color: 'rgb(151, 1, 14)', textAlign: 'center', fontFamily: 'Ysabeau SC, sans-serif' }}>{editingOrg ? 'Редактирование' : 'Новая организация'}</h3>
                <form onSubmit={handleSubmit}>
                  <div className={s.formSection} style={{ marginBottom: '1.5rem' }}>
                    <label className={s.label} style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Название:</label>
                    <input
                      name="name"
                      defaultValue={editingOrg?.name}
                      required
                      className={s.input}
                      style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
                    />
                  </div>
                  <div className={s.formSection} style={{ marginBottom: '1.5rem' }}>
                    <label className={s.label} style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Руководитель:</label>
                    {renderLeaderSearch()}
                  </div>
                  <div className={s.formSection} style={{ marginBottom: '1.5rem' }}>
                    <label className={s.label} style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Описание:</label>
                    <textarea
                      name="description"
                      defaultValue={editingOrg?.description}
                      className={s.input}
                      style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
                    />
                  </div>
                  <div className={s.formSection} style={{ marginBottom: '1.5rem' }}>
                    <label className={s.label} style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Местоположение:</label>
                    <input
                      name="location"
                      defaultValue={editingOrg?.location}
                      className={s.input}
                      style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '2rem' }}>
                    <button type="submit" className={s.saveButton} style={{ backgroundColor: 'rgb(151, 1, 14)', color: 'white', borderRadius: 4, padding: '0.8rem 1.5rem', fontSize: '1rem' }}>
                      Сохранить
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setIsModalOpen(false);
                        setEditingOrg(null);
                        setSearchQuery('');
                      }}
                      className={s.cancelButton}
                      style={{ backgroundColor: '#666', color: 'white', borderRadius: 4, padding: '0.8rem 1.5rem', fontSize: '1rem' }}
                    >
                      Отмена
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Organizations;